import React, { useEffect, useMemo } from 'react';
import { ThreeElements } from '@react-three/fiber';

import { BearingEnvelope } from '@paragon/contract-library';
import { Polygon2D } from '@paragon/geometry-library';

import { calculateBufferGeometryForBearingEnvelopeShape } from '../../../store/selectors/layoutDocumentSelectors';
import { getBearingEnvelopeColors, layoutColors } from '../layoutColors';
import { LayoutSolidVisual } from '../LayoutSolidVisual';
import { SOLID_BEARING_OPACITY } from './BearingFlatVisual';

interface OwnProps {
  wireframe?: boolean;
  dashed?: boolean;

  envelope: BearingEnvelope;

  shape: Polygon2D;
  structural: boolean;
  style: 'faded' | 'emphasised' | 'normal';
}

export function BearingSolidVisual(props: OwnProps & Partial<ThreeElements['group']>) {
  const { envelope, shape, dashed, ...rest } = props;
  const { top, bottom } = envelope;

  const geometry = useMemo(
    () => calculateBufferGeometryForBearingEnvelopeShape(shape, { top, bottom }),
    [shape, top, bottom],
  );

  useEffect(() => () => geometry?.dispose(), [geometry]);

  if (geometry == null) return null;

  const color = getBearingEnvelopeColors(envelope.bearingType, props.structural)[props.style];

  return (
    <LayoutSolidVisual
      {...rest}
      geometry={geometry}
      meshColor={color}
      opacity={SOLID_BEARING_OPACITY}
      edgeColor={rest.wireframe ? color : layoutColors.solidMeshEdges}
      dashed={dashed}
    />
  );
}
